<template>
  <div :class="{ 'is-required': required }">
    <label v-if="label && label != null" class="label dfdf" for="">
      {{ label }}
    </label>
    <div v-if="value">
      <slot
        name="selection"
        :remove="remove"
        :valueLabel="valueLabel"
        :value="value"
      >
        <div
          class="chip"
          :class="{ 'is-disabled': disabled, 'is-shadowless': true }"
        >
          {{ valueLabel }}
          <button
            v-if="!disabled"
            type="button"
            class="delete"
            @click="remove()"
          />
        </div>
      </slot>
    </div>
    <b-autocomplete
      v-else
      ref="autocompleteFetch"
      v-model="query"
      autocomplete
      :data="data"
      :icon="icon"
      :placeholder="placeholder"
      :field="field"
      :clearable="clearable"
      :maxlength="maxlength"
      :open-on-focus="openOnFocus"
      :keep-first="keepFirst"
      :disabled="disabled"
      :loading="isFetching"
      :append-to-body="appendToBody"
      :check-infinite-scroll="true"
      @select="onInput"
      @infinite-scroll="onScrollBottom"
      @typing="onTyping"
    >
      <div slot-scope="props">
        <slot v-bind="props">
          {{ getLabel(props.option) }}
        </slot>
      </div>
      <template slot="footer">
        <slot name="footer" />
      </template>
      <template slot="empty">
        {{ $t("no_data") }}
      </template>
    </b-autocomplete>
  </div>
</template>

<script>
export default {
  props: {
    value: {
      default: null,
      validator(value) {
        return _.isString(value) || _.isObject(value);
      },
    },
    route: {
      required: true,
      type: String,
    },
    label: {
      required: false,
      default: "",
      type: String,
    },
    field: {
      default: undefined,
      type: String,
    },
    icon: {
      default: "magnify",
      type: String,
    },
    maxlength: {
      type: Number,
      default: undefined,
    },
    openOnFocus: {
      type: Boolean,
      default: false,
    },
    keepFirst: {
      type: Boolean,
      default: false,
    },
    parameters: {
      default() {
        return {};
      },
      type: Object,
    },
    placeholder: {
      default: null,
      type: String,
    },
    disabled: {
      default: false,
      type: Boolean,
    },
    required: {
      default: false,
      type: Boolean,
    },
    clearable: {
      default: false,
      type: Boolean,
    },
    appendToBody: {
      default: true,
      type: Boolean,
    },
  },
  data() {
    return {
      query: "",
      page: 1,
      data: [],
      isFetching: false,
      lastPage: 1,
    };
  },
  computed: {
    valueLabel() {
      return this.getLabel(this.value);
    },
  },
  watch: {
    value(value) {
      if (!value) {
        this.query = "";
      }
    },
  },
  created() {
    if (this.openOnFocus) {
      this.fetch();
    }
  },
  methods: {
    onTyping(query) {
      this.query = query;
      this.page = 1;
      this.lastPage = null;
      this.$emit("typing", query);
      this.getAsyncData();
    },
    getAsyncData: _.debounce(function () {
      this.fetch();
    }, 500),
    onScrollBottom() {
      this.page++;
      if (this.page <= this.lastPage) {
        this.fetch();
      }
    },
    fetch() {
      this.isFetching = true;

      let internalParameters = {
        page: this.page,
        search: this.query,
      };

      let params = _.merge(internalParameters, this.parameters);

      this.$http
        .get(`${this.route}`, {
          params: params,
        })
        .then(({ data }) => {
          if (this.page == 1) {
            this.data = [];
          }

          let items = data;
          if (_.isObject(items)) {
            items = items.data;
          }

          items.forEach((item) => this.data.push(item));

          this.lastPage = data.meta.last_page ?? null;
        })
        .catch((error) => {
          this.data = [];
          throw error;
        })
        .finally(() => {
          this.isFetching = false;
        });
    },
    onInput(event) {
      this.$emit("input", event);
    },
    remove() {
      this.onInput(null);
    },
    getLabel(option) {
      if (_.isString(option)) {
        return option;
      }
      return option[this.field];
    },
  },
};
</script>
